import { render } from "./FooterPixParcelado.vue?vue&type=template&id=153b174d&scoped=true"
import script from "./FooterPixParcelado.vue?vue&type=script&lang=js"
export * from "./FooterPixParcelado.vue?vue&type=script&lang=js"

import "./FooterPixParcelado.vue?vue&type=style&index=0&id=153b174d&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b174d"]])

export default __exports__